// removed by extract-text-webpack-plugin
module.exports = {"tabs":"fnancialOverview_tabs_2aonS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/fnancialOverview.scss
// module id = 1566
// module chunks = 0